import { DataService } from "../../../../shared/session/index";
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { SessionInfo } from "../../../../shared/session/SessionInfo";
import { Imodule } from './../shared/module.model';

@Injectable()
export class ModuleService {
    constructor(private dataService: DataService, private sessionInfo: SessionInfo) { }
    private insertarModuleUrl: string = 'module/insertar';
    private actualizarModuleUrl: string = 'module/actualizar';
    private obtenerModuleUrl: string = 'module/obtener';
    private listarModuleUrl: string = 'module/listar';
    private listarPorModulosUrl: string = 'module/listarPor';
    private listarPorAccesoUrl: string = 'module/listarPorAcceso';


    listarModule(): any {
        this.dataService.set(this.listarModuleUrl);
        return this.dataService.execGetJson();
    }


    listarPorModulos(filtro: string, pAplicacionID: number, pageIndex: number, pageSize: number): any {
        let parameters = new HttpParams();
        parameters = parameters.append("pFiltro", filtro);
        parameters = parameters.append("pAplicacionID", String(pAplicacionID));
        this.dataService.set(this.listarPorModulosUrl);
        return this.dataService.execGetJson(parameters);
    }

    obtenerModule(moduleID: number): any {
        let parameters = new HttpParams();
        parameters = parameters.append("pKey", String(moduleID));
        this.dataService.set(this.obtenerModuleUrl);
        return this.dataService.execGetJson(parameters);
    }

    insertarModule(modules: Imodule): any {
        let parameters: string;
        parameters = JSON.stringify({
            Name: modules.Name,
            AplicacionID: modules.AplicacionID,
            Descripcion: modules.Descripcion,
            Status: modules.Status,
            UserCreation: this.sessionInfo.getCodUsuario(),
        });

        this.dataService.set(this.insertarModuleUrl);
        return this.dataService.execPostJson(parameters);
    }

    actualizarModule(modules: Imodule): any {
        let parameters: string;
        parameters = JSON.stringify({
            ModuleID: String(modules.ModuleID),
            Name: modules.Name,
            Descripcion: modules.Descripcion,
            Status: modules.Status,
            userlastupdate: this.sessionInfo.getCodUsuario(),
            AplicacionID: String(modules.AplicacionID)
        });

        this.dataService.set(this.actualizarModuleUrl);
        return this.dataService.execPostJson(parameters);
    }

    listarPorAcceso(idUsuario: number, idAplicacion: number, idNivelAcceso: number, idEntidad: number, idRol: number): any {
        let parameters = new HttpParams();
        parameters = parameters.append("idUsuario", String(idUsuario));
        parameters = parameters.append("idAplicacion", String(idAplicacion));
        parameters = parameters.append("idNivelAcceso", String(idNivelAcceso));
        parameters = parameters.append("idEntidad", String(idEntidad));
        parameters = parameters.append("idRol", String(idRol));
        this.dataService.set(this.listarPorAccesoUrl);
        return this.dataService.execGetJson(parameters);
    }
}